/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { getSVGIconForDocument } from "cms/documents/document/helpers";
import { formatBytes } from "utils/format-bytes";

const DocumentFormatCardIcon = (props) => {

    const { document, onClickHandler } = props || {};

    return (
        <Fragment>
            {document &&
                <div className='document-select-card' onClick={onClickHandler}>
                    <div>
                        <div className='document-display-icon'>
                            {getSVGIconForDocument(document)}
                        </div>
                        <div className='document-display-container'>
                            <div className='document-display-heading'>
                                {document.title}
                            </div>
                            <div className='document-display-size'>
                                {formatBytes(document.file_size)}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
};

export { DocumentFormatCardIcon };
